import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Popconfirm, message } from 'antd';
import { DeleteOutlined, EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function Gallery() {
	const [gridLoading, setGridLoading] = useState(true);
	const [gridData, setGridData] = useState([]);

	const get = () => {
		axios
			.get('/gallery')
			.then((result) => {
				setGridData(result.data.data);
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const deleteRecord = (record) => {
		setGridLoading(true);
		axios
			.delete('/gallery', { data: { _id: record._id } })
			.then((result) => {
				message.success(result.data.message);
				get();
			})
			.catch(() => {
				message.error('Oops! Something went wrong!');
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'Gallery' }]} />
			<div className='main-content'>
				<div className='page-header'>
					<div className='page-title'>Gallery</div>
					<div className='page-title-more'>
						<Link to='/gallery/add'>
							<Button icon={<PlusCircleOutlined />} type='primary'>
								Add
							</Button>
						</Link>
					</div>
				</div>
				<div className='grid-content'>
					<Table
						bordered
						size='small'
						rowKey='_id'
						loading={gridLoading}
						dataSource={gridData}
						pagination={{ pageSize: 10 }}
						columns={[
							{
								title: 'Action',
								key: 'action',
								align: 'center',
								render: (text, record) => (
									<div style={{ display: 'flex', justifyContent: 'space-around' }}>
										<Link to={`/gallery/edit/${record._id}`}>
											<EditOutlined className='grid-edit-icon' />
										</Link>
										<Popconfirm title='Are you sure you want to delete this record?' okText='Yes' cancelText='No' onConfirm={() => deleteRecord(record)}>
											<DeleteOutlined style={{ fontSize: 14 }} />
										</Popconfirm>
									</div>
								),
							},
							{
								title: 'Gallery Images',
								dataIndex: 'media',
								render: (media) => {
									if (Array.isArray(media) && media.length > 0 && media[0].mediaPath) {
										return media.map((img) => <img key={img._id} src={img.mediaPath} alt={img.mediaTitle || ''} width={100} height={100} style={{ marginRight: 5 }} />);
									}
									return 'No Images';
								},
							},
						]}
					/>
				</div>
			</div>
		</>
	);
}

export default Gallery;
